import React from 'react';

const TestPage = () => {
  return (
    <div style={{ padding: '20px', color: 'white', backgroundColor: '#1a1a1a' }}>
      <h1>Test Page</h1>
      <p>If you can see this, the React app is working!</p>
      <p>Environment variables:</p>
      <ul>
        <li>VITE_SUPABASE_URL: {import.meta.env.VITE_SUPABASE_URL ? 'Set' : 'Not Set'}</li>
        <li>VITE_SUPABASE_ANON_KEY: {import.meta.env.VITE_SUPABASE_ANON_KEY ? 'Set' : 'Not Set'}</li>
      </ul>
    </div>
  );
};

export default TestPage; 